import { showToast } from '@finn/design-system/atoms/toast';
import axios from 'axios';
import dayjs from 'dayjs';
import { useCallback } from 'react';

import { useDealId } from '../../../providers/MetadataProvider';
import {
  UpdatePickupReturn,
  UpdateReturnData,
  UpdateSelfReturn,
} from '../../../types/bff-api';

type UseFormSubmit = {
  success_toast_title?: string;
  success_toast_description?: string;
  error_toast_title?: string;
  error_toast_description?: string;
};

export const useUpdateReturnFormSubmit = ({
  success_toast_title,
  success_toast_description,
  error_toast_title,
  error_toast_description,
}: UseFormSubmit) => {
  const dealId = useDealId();

  const handleSubmit = useCallback(
    async (values: UpdateReturnData) => {
      let payload: UpdateSelfReturn | UpdatePickupReturn;
      const preferredReturnDate = dayjs(new Date(values.preferred_return_date))
        .tz('Europe/Berlin')
        .toISOString();

      if (values.return_type === 'SELF_RETURN') {
        payload = {
          return_type: values.return_type,
          preferred_return_date: preferredReturnDate,
        };
      }

      if (values.return_type === 'PICKUP') {
        payload = {
          ...values,
          preferred_return_date: preferredReturnDate,
        };
      }

      try {
        await axios.put(`/portal/api/bff/deals/${dealId}/return`, payload);

        showToast({
          title: success_toast_title,
          description: success_toast_description,
          status: 'success',
        });

        return 200;
      } catch (error) {
        showToast({
          title: error_toast_title,
          description: error_toast_description,
          status: 'error',
        });

        return 500;
      }
    },
    [
      dealId,
      success_toast_title,
      success_toast_description,
      error_toast_title,
      error_toast_description,
    ]
  );

  return { handleSubmit };
};
